import { trackEvent } from '@patrianna/analytics'
import { useMediaQuery } from '@patrianna/shared-hooks'
import { nextTick } from '@patrianna/shared-utils'
import { useRouter } from 'next/navigation'

import BannerTile from 'components/BannerTile'
import { useAppDispatch } from 'src/store/hooks'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'
import { openShopHandler } from 'store/modules/shop/actions'

function FirstTimeGCOffers() {
  const router = useRouter()
  const isMobile = useMediaQuery('xs')
  const dispatch = useAppDispatch()
  const bannerUrl = generateImageUrl(
    `banners/1st-purchase-offer-${process.env.BRAND_NAME}/source.png`,
    ImagesDirectory.BANNERS,
  )

  const onOfferBannerClick = () => {
    nextTick().then(() => {
      trackEvent('clicked_on_banner', { category: 'first-time-gc-offer-banner' })
      dispatch(openShopHandler(isMobile, router.push))
    })
  }

  return (
    <BannerTile
      onClick={onOfferBannerClick}
      src={bannerUrl}
      alt='shop banner'
      dataTest='first-time-gc-offer-banner'
      loading='eager'
    />
  )
}

export default FirstTimeGCOffers
